import { SvgIcon } from '@mui/material';
import { ReactComponent as errorSVG } from './error.svg';

export default function ImgErrorNetwork(props) {
  return <SvgIcon component={errorSVG} viewBox="0 0 109 108" {...props} />;
}